export const common = {
  common: {
    firstLoginHeading: 'Connexion réussie!',
    firstLoginGreeting: 'Bienvenue à',
    cancel: 'Annuler',
    delete: 'Supprimer',
    remove: 'Retirer',
    edit: 'Modifier',
    restore: 'Restaurer',
    back: 'Zurück',
    next: 'Weiter',
    submit: 'Soumettre',
    continue: 'Continuer',
    save: 'Sauvez',
    done: 'Terminé',
    home: 'Accueil',
    noData: 'Pas de données.',
    confirm: 'Confirmer',
    more: 'plus',
    close: 'Fermer',
    loading: 'Chargement',
    loaded: 'chargé',
    menu: 'Menu',
    reset: 'Réinitialiser',
    search: 'Recherche',
    add: 'Ajouter',
    create: 'Créer',
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    move: 'Déplacements',
    update: 'Renommer',
    readArticle: "Lire l'article",
    toFaqs: 'Vers la FAQ',
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} résultat pour {{query}}',
      title_plural: '{{count}} résultat pour {{query}}',
    },
    checkout: {
      title: 'Checkout',
    },
    search: {
      title: '{{count}} résultat pour "{{query}}"',
      title_plural: '{{count}} résultat pour "{{query}}"',
      findProductTitle: '{{count}} résultat pour le coupon "{{coupon}}"',
      findProductTitle_plural: '{{count}} résultat pour le coupon "{{coupon}}"',
      default_title: 'Tous les produits',
    },
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}}',
    },
  },
  spinner: {
    loading: 'Chargement...',
  },
  navigation: {
    shopAll: 'Magasinez tout {{ navNode}} >',
  },
  searchBox: {
    placeholder: 'Cherche ici...',
    ariaLabelInput: 'Cherche ici...',
    ariaLabelSuggestions: 'suggestions de saisie',
    ariaLabelProducts: 'résultats du produit',
    initialDescription:
      "Lorsque les résultats de la saisie semi-automatique sont disponibles, utilisez les flèches haut et bas pour les consulter et la touche Entrée pour les sélectionner. Utilisateurs d'appareils tactiles, explorez par le toucher ou par des gestes de balayage.",
    suggestionsResult: '{{ count }} suggestion et ',
    suggestionsResult_plural: '{{ count }} suggestions et ',
    productsResult: '{{ count }} produit disponible.',
    productsResult_plural: '{{ count }} produits sont disponibles.',
    resetLabel: 'Réinitialiser recherche',
    help: {
      insufficientChars: 'Veuillez taper plus de caractères',
      noMatch: "Nous n'avons pas pu trouver de résultats",
      exactMatch: '{{ term }}',
      empty: "Demandez-nous n'importe quoi",
    },
  },
  sorting: {
    date: 'Date',
    orderNumber: 'Numéro de commande',
    rma: 'Numéro de retour',
    replenishmentNumber: 'Numéro de réapprovisionnement',
    nextOrderDate: 'Prochaine commande',
  },
  httpHandlers: {
    badGateway: "Une erreur de serveur s'est produite.Veuillez réessayer plus tard.",
    badRequestPleaseLoginAgain:
      "'Malheureusement, cela n'a pas fonctionné. Veuillez vérifier si vous utilisez la bonne adresse e-mail et le bon mot de passe.",
    badRequestOldPasswordIncorrect: 'Ancien mot de passe incorrect.',
    badRequestGuestDuplicateEmail:
      "{{ errorMessage }} L'email existe déjà.Veuillez vérifier avec une autre adresse électronique pour vous inscrire en utilisant un compte invité.",
    conflict: 'Il existe déjà.',
    forbidden:
      "Vous n'êtes pas autorisé à effectuer cette action.Veuillez contacter votre administrateur si vous pensez qu'il s'agit d'une erreur.",
    gatewayTimeout: "Le serveur n'a pas répondu, veuillez réessayer plus tard.",
    internalServerError: "Le serveur n'a pas répondu, veuillez réessayer plus tard.",
    sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
    unknownError: "Une erreur inconnue s'est produite",
    unauthorized: {
      common: "Une erreur d'autorisation inconnue s'est produite",
      invalid_client: 'Mauvais identifiants du client',
    },
    validationErrors: {
      missing: {
        card_cardType:
          "La carte de crédit sélectionnée n'est pas prise en charge.Veuillez en sélectionner une autre.",
        card_accountNumber: "Le numéro de carte de crédit saisi n'est pas valide.",
        card_cvNumber: "Le code de sécurité saisi n'est pas valide.",
        card_expirationMonth: "La date d'expiration de la carte de crédit saisie n'est pas valide.",
        card_expirationYear: "La date d'expiration de la carte de crédit saisie n'est pas valide.",
        billTo_firstName: "Le premier nom saisi n'est pas valide.",
        billTo_lastName: "Le nom de famille saisi n'est pas valide.",
        billTo_street1: "L'adresse saisie n'est pas valide.",
        billTo_street2: "L'adresse saisie n'est pas valide.",
        billTo_city: "La ville saisie n'est pas valable pour cette carte de crédit.",
        billTo_state: "L'état/la province saisi(e) n'est pas valable pour cette carte de crédit.",
        billTo_country:
          "Le pays/la région indiqué(e) n'est pas valable pour cette carte de crédit.",
        billTo_postalCode: "Le code postal n'est pas valide pour cette carte de crédit.",
        country: {
          isocode: 'Pays/région manquant',
        },
      },
      invalid: {
        card_expirationMonth: "La date d'expiration de la carte de crédit saisie n'est pas valide.",
        firstName: "Le prénom saisi n'est pas valide.",
        lastName: "Le nom de famille saisi n'est pas valide.",
        password: "Le mot de passe saisi n'est pas valide.",
        uid: "L'e-mail n'est pas valide.",
        code: "Le code n'est pas valide.",
        email: "L'email n'est pas valide.",
        login: "L'email n'est pas valide.",
      },
    },
    cartNotFound: 'Panier non trouvé.',
    invalidCodeProvided: "Le code fourni n'est pas valide.",
  },
  miniCart: {
    item: '{{count}} article actuellement dans votre panier',
    item_plural: '{{count}} article actuellement dans votre panier',
    total: '{{total}}',
    count: '{{count}}',
  },
  skipLink: {
    skipTo: 'Passer à',
    labels: {
      header: 'Entête',
      main: 'Contenu principal',
      footer: 'Footer',
      productFacets: 'Facettes du produit',
      productList: 'Liste des produits',
    },
  },
  formErrors: {
    globalMessage: 'Le formulaire que vous essayez de soumettre contient des erreurs.',
    required: 'Champ obligatoire',
    cxInvalidEmail: "Ce n'est pas un format de courriel valide",
    cxInvalidPassword: "Ce n'est pas un format de mot de passe valide",
    cxPasswordsMustMatch: 'Les champs du mot de passe doivent correspondre',
    cxEmailsMustMatch: "Les champs de l'e- mail doivent correspondre",
    cxStarRatingEmpty: 'Le champ "Classement" est obligatoire',
    cxNoSelectedItemToCancel: 'Sélectionnez au moins un élément',
    cxNegativeAmount: 'Le montant doit être égal ou supérieur à zéro',
    cxContainsSpecialCharacters: 'Le champ ne peut pas contenir de caractères spéciaux',
    date: {
      required: 'Ce champ est obligatoire',
      min: 'La date ne peut être antérieure à {{min}}',
      max: 'La date ne peut être postérieure à {{max}}',
      pattern: 'Utiliser le format de date yyyy-mm-dd',
      invalid: 'Utiliser une date valide',
    },
  },
  errorHandlers: {
    scriptFailedToLoad: 'Échec du chargement du script.',
    refreshThePage: 'Veuillez rafraîchir la page.',
  },
};
